(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var compileJade = require('browjadify-compile')
  , formErrorsTemplate = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (displayKey, errors, result, undefined) {
buf.push("<div role=\"alert\" class=\"alert alert-danger\"><strong>Oops! Something isn't right.</strong><p>Please check and try again.</p><ul>");
// iterate errors
;(function(){
  var $$obj = errors;
  if ('number' == typeof $$obj.length) {

    for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
      var error = $$obj[key];

if ( typeof error === 'object')
{
// iterate error
;(function(){
  var $$obj = error;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var e = $$obj[$index];

if ( typeof e === 'object')
{
// iterate e
;(function(){
  var $$obj = e;
  if ('number' == typeof $$obj.length) {

    for (var k = 0, $$l = $$obj.length; k < $$l; k++) {
      var err = $$obj[k];

result = key.replace(/([A-Z])/g, " $1")
displayKey = result.charAt(0).toUpperCase() + result.slice(1)
buf.push("<li>" + (jade.escape((jade_interp = displayKey) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = err) == null ? '' : jade_interp)) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var k in $$obj) {
      $$l++;      var err = $$obj[k];

result = key.replace(/([A-Z])/g, " $1")
displayKey = result.charAt(0).toUpperCase() + result.slice(1)
buf.push("<li>" + (jade.escape((jade_interp = displayKey) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = err) == null ? '' : jade_interp)) + "</li>");
    }

  }
}).call(this);

}
else
{
buf.push("<li>" + (jade.escape((jade_interp = e) == null ? '' : jade_interp)) + "</li>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var e = $$obj[$index];

if ( typeof e === 'object')
{
// iterate e
;(function(){
  var $$obj = e;
  if ('number' == typeof $$obj.length) {

    for (var k = 0, $$l = $$obj.length; k < $$l; k++) {
      var err = $$obj[k];

result = key.replace(/([A-Z])/g, " $1")
displayKey = result.charAt(0).toUpperCase() + result.slice(1)
buf.push("<li>" + (jade.escape((jade_interp = displayKey) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = err) == null ? '' : jade_interp)) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var k in $$obj) {
      $$l++;      var err = $$obj[k];

result = key.replace(/([A-Z])/g, " $1")
displayKey = result.charAt(0).toUpperCase() + result.slice(1)
buf.push("<li>" + (jade.escape((jade_interp = displayKey) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = err) == null ? '' : jade_interp)) + "</li>");
    }

  }
}).call(this);

}
else
{
buf.push("<li>" + (jade.escape((jade_interp = e) == null ? '' : jade_interp)) + "</li>");
}
    }

  }
}).call(this);

}
else
{
buf.push("<li>" + (jade.escape((jade_interp = error) == null ? '' : jade_interp)) + "</li>");
}
    }

  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;      var error = $$obj[key];

if ( typeof error === 'object')
{
// iterate error
;(function(){
  var $$obj = error;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var e = $$obj[$index];

if ( typeof e === 'object')
{
// iterate e
;(function(){
  var $$obj = e;
  if ('number' == typeof $$obj.length) {

    for (var k = 0, $$l = $$obj.length; k < $$l; k++) {
      var err = $$obj[k];

result = key.replace(/([A-Z])/g, " $1")
displayKey = result.charAt(0).toUpperCase() + result.slice(1)
buf.push("<li>" + (jade.escape((jade_interp = displayKey) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = err) == null ? '' : jade_interp)) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var k in $$obj) {
      $$l++;      var err = $$obj[k];

result = key.replace(/([A-Z])/g, " $1")
displayKey = result.charAt(0).toUpperCase() + result.slice(1)
buf.push("<li>" + (jade.escape((jade_interp = displayKey) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = err) == null ? '' : jade_interp)) + "</li>");
    }

  }
}).call(this);

}
else
{
buf.push("<li>" + (jade.escape((jade_interp = e) == null ? '' : jade_interp)) + "</li>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var e = $$obj[$index];

if ( typeof e === 'object')
{
// iterate e
;(function(){
  var $$obj = e;
  if ('number' == typeof $$obj.length) {

    for (var k = 0, $$l = $$obj.length; k < $$l; k++) {
      var err = $$obj[k];

result = key.replace(/([A-Z])/g, " $1")
displayKey = result.charAt(0).toUpperCase() + result.slice(1)
buf.push("<li>" + (jade.escape((jade_interp = displayKey) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = err) == null ? '' : jade_interp)) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var k in $$obj) {
      $$l++;      var err = $$obj[k];

result = key.replace(/([A-Z])/g, " $1")
displayKey = result.charAt(0).toUpperCase() + result.slice(1)
buf.push("<li>" + (jade.escape((jade_interp = displayKey) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = err) == null ? '' : jade_interp)) + "</li>");
    }

  }
}).call(this);

}
else
{
buf.push("<li>" + (jade.escape((jade_interp = e) == null ? '' : jade_interp)) + "</li>");
}
    }

  }
}).call(this);

}
else
{
buf.push("<li>" + (jade.escape((jade_interp = error) == null ? '' : jade_interp)) + "</li>");
}
    }

  }
}).call(this);

buf.push("</ul></div>");}.call(this,"displayKey" in locals_for_with?locals_for_with.displayKey:typeof displayKey!=="undefined"?displayKey:undefined,"errors" in locals_for_with?locals_for_with.errors:typeof errors!=="undefined"?errors:undefined,"result" in locals_for_with?locals_for_with.result:typeof result!=="undefined"?result:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}
  , formErrorTemplate = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (error, undefined) {
if ( typeof error === 'object')
{
buf.push("<div class=\"form-copy form-error\"><ul>");
// iterate error
;(function(){
  var $$obj = error;
  if ('number' == typeof $$obj.length) {

    for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
      var err = $$obj[key];

buf.push("<li>" + (jade.escape((jade_interp = err) == null ? '' : jade_interp)) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;      var err = $$obj[key];

buf.push("<li>" + (jade.escape((jade_interp = err) == null ? '' : jade_interp)) + "</li>");
    }

  }
}).call(this);

buf.push("</ul></div>");
}
else
{
buf.push("<div class=\"form-error\"><div class=\"form-error-content\">" + (jade.escape(null == (jade_interp = error) ? "" : jade_interp)) + "<br/></div><div class=\"form-error-arrow\"><div class=\"line10\"></div><div class=\"line9\"></div><div class=\"line8\"></div><div class=\"line7\"></div><div class=\"line6\"></div><div class=\"line5\"></div><div class=\"line4\"></div><div class=\"line3\"></div><div class=\"line2\"></div><div class=\"line1\"></div></div></div>");
}}.call(this,"error" in locals_for_with?locals_for_with.error:typeof error!=="undefined"?error:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}

function showErrors (errors) {
  this.clearErrors()

  var $errors = formErrorsTemplate({ errors: errors })
    , firstError = Object.keys(errors)[0]
  Object.keys(errors).forEach(function (key) {
    this.$('[data-field="' + key + '"] .js-error')
      .append(formErrorTemplate({ error: errors[key] }))
  }.bind(this))
  this.$('.js-errors-summary').append($errors)
  // Set the focus to the first error
  this.$(':input[name=' + firstError + ']').focus()
}

function clearErrors () {
  this.$('.js-errors-summary, .js-error').empty()
}

module.exports = function () {
  return {
      showErrors: showErrors
    , clearErrors: clearErrors
    }
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/form-errors-delegate.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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